import React from 'react';
import FlexLayout from '../FlexLayout';
import Text from '../Text';
import * as Barcode from 'react-barcode';

const fontSize = '18px';

const blackVerticalAlign = {
  color: 'white',
  background: 'black',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  fontSize: fontSize,
  fontWeight: 600
}

const whiteVerticalAlign = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  padding: '1.5px',
  fontSize: fontSize,
  fontWeight: 600
}

const section = {
  border: '1px solid black',
  borderBox: 'content-box',
}

const bold = {
  fontWeight: 600,
  fontSize: '20px',
}

const barcodeStyle = {
    maxHeight: '100px',
    width: '100%',
}

function WithdrawLabel({obj}) {
    return (
        <FlexLayout direction="column" style={{ maxWidth: '11cm', maxHeight: '9cm', border: '2px solid black' }}>
            <FlexLayout justify="between">
                <FlexLayout style={{ ...section, width: '30%' }}>
                    <Text plainText={'Saída ' + obj.warehouse} style={{ ...whiteVerticalAlign, ...bold }} />
                </FlexLayout>
                <FlexLayout style={{ ...section, width: '70%' }}>
                    <Text text="label.withdrawDate" style={{ ...whiteVerticalAlign, fontSize: '14px', width: '40%' }} />
                    <Text plainText={obj.withdrawDate} style={{ ...whiteVerticalAlign, fontSize: '14px', width: '60% ' }} />
                </FlexLayout>
            </FlexLayout>
            <FlexLayout direction="column" align="center" style={barcodeStyle}>
                <Text plainText={obj.fc} style={{...bold}}/>
                <FlexLayout justify="center">
                    <Barcode width='2' height='25' displayValue='false' value={obj.barcodeSku} />
                </FlexLayout>
            </FlexLayout>
            <FlexLayout align="center" justify="around" style={{ ...section, fontSize: '10px', height: '40px', wordBreak: 'break-all', padding:'30px 0' }}>
                <Text text="label.description" style={{ ...whiteVerticalAlign, width: '150px' }} />
                <Text plainText={obj.description} style={{ ...whiteVerticalAlign }} />
            </FlexLayout>
            <FlexLayout justify="between">
                <FlexLayout style={{ ...section, fontSize: '10px' }}>
                    <Text text="label.model" style={{ ...whiteVerticalAlign }} />
                    <Text plainText={obj.codModelo} style={{ ...whiteVerticalAlign }} />
                </FlexLayout>
                <FlexLayout style={{ ...section, fontSize: '10px' }}>
                    <Text text="label.barcode" style={{ ...whiteVerticalAlign }} />
                    <Text plainText={obj.barcodeSku} style={{ ...whiteVerticalAlign }} />
                </FlexLayout>
            </FlexLayout>
            <FlexLayout style={section}>
                <FlexLayout justify="between" style={{ width: '30%' }}>
                    <Text plainText={obj.warehouse} style={{ ...blackVerticalAlign, ...bold, fontSize: '35px' }} />
                </FlexLayout>
                <FlexLayout direction="column" style={{ width: '70%' }}>
                    <FlexLayout justify="center" style={section}>
                        <FlexLayout direction="column" align="center">
                            <Text text="label.street" style={{ ...blackVerticalAlign, ...bold }} />
                            <Text plainText={obj.street} style={{ ...blackVerticalAlign, ...bold }} />
                        </FlexLayout>
                        <FlexLayout direction="column" align="center">
                            <Text text="label.shelf" style={{ ...blackVerticalAlign, ...bold }} />
                            <Text plainText={obj.shelf} style={{ ...blackVerticalAlign, ...bold }} />
                        </FlexLayout>
                        <FlexLayout direction="column" align="center">
                            <Text text="label.bin" style={{ ...blackVerticalAlign, ...bold }} />
                            <Text plainText={obj.bin} style={{ ...blackVerticalAlign, ...bold }} />
                        </FlexLayout>
                    </FlexLayout>
                    <FlexLayout justify="center" style={{ ...section, height: '100%' }}>
                        <FlexLayout direction="column" align="center" style={{ marginTop: '5px' }}>
                            <Text text="label.addressBarcode" />
                            <FlexLayout justify="center">
                                <Barcode width='2' height='25' displayValue='false' value={obj.addressBarcode} />
                            </FlexLayout>
                        </FlexLayout>
                    </FlexLayout>
                </FlexLayout>
            </FlexLayout>
        </FlexLayout >
    );
}

export default WithdrawLabel;
